export default __webpack_public_path__ + "static/media/LAMP.3d7bc0e4.jpg";